<div class="row">
        <div class="card-body prpl">
            <div class="row">
                <div *ngIf="submitButton">
                    <h4 class="main-content-label mb-2"><b>{{ 'header.code-data.table.AddNewCodeRecord' | translate
                            }}</b></h4>
                </div>
                <div *ngIf="editButton">
                    <h4 class="main-content-label mb-2"><b>{{ 'header.code-data.table.UpdateCodeRecord' | translate
                            }}</b></h4>
                </div>
                <div *ngIf="deleteButton">
                    <h4 class="main-content-label mb-2"> <b>{{'header.code-data.table.DeleteCodeRecord' |
                            translate}} </b>
                    </h4>
                </div>
                <form autocomplete="off" class="p-0" novalidate [formGroup]="codeForm ">
                    <div class="col-lg-12 col-md-12 prpl">
                        <div class="row clearfix">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <div class="">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>{{ 'header.code-data.table.CodeType' | translate }}</mat-label> <input
                                                onkeydown="return (event.keyCode!=13);" matInput readonly
                                                formControlName="CdType">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <div class="">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>{{ 'header.code-data.table.CodeDescription' | translate }}</mat-label> <input
                                                onkeydown="return (event.keyCode!=13);" matInput readonly
                                                formControlName="desLabel">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <div class="">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>{{ 'header.code-data.table.Code' | translate
                                                }}</mat-label>
                                            <input [readonly]="isReadonly" onkeydown="return (event.keyCode!=13);"
                                                matInput formControlName="CdCode" placeholder="Code" maxlength="6"
                                                required>
                                            <mat-error class="margin_tp"
                                                *ngIf="codeForm.controls['CdCode'].touched && codeForm.controls['CdCode'].errors?.required">
                                             {{ 'header.code-data.table.Mandatory' | translate }} </mat-error>
                                            <mat-error class="margin_tp"
                                                *ngIf="codeForm.controls['CdCode'].touched && codeForm.controls['CdCode'].errors?.pattern">
                                                {{ 'header.code-data.table.Invalid' | translate }}
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <div class="">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>{{ 'header.code-data.table.CodeDescription' | translate
                                                }}</mat-label> <input onkeydown="return (event.keyCode!=13);" matInput
                                                formControlName="CdDesc" [readonly]="isReadonlyDelete" maxlength="200"
                                                placeholder="Code Description" required>
                                            <mat-error class="margin_tp"
                                                *ngIf="codeForm.controls['CdDesc'].touched && codeForm.controls['CdDesc'].errors?.required">
                                                {{ 'header.code-data.table.Mandatory' | translate }} </mat-error>
                                            <mat-error class="margin_tp"
                                                *ngIf="codeForm.controls['CdDesc'].touched && codeForm.controls['CdDesc'].errors?.pattern">
                                                {{ 'header.code-data.table.Invalid' | translate }} 
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <div class="">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>{{ 'header.code-data.table.CodeSequence' | translate
                                                }}</mat-label> <input onkeydown="return (event.keyCode!=13);" matInput
                                                formControlName="CdSeq" maxlength="4" [readonly]="isReadonlyDelete"
                                                placeholder="Code Sequence" required>
                                            <mat-error class="margin_tp"
                                                *ngIf="codeForm.controls['CdSeq'].touched && codeForm.controls['CdSeq'].errors?.required">
                                                {{ 'header.code-data.table.Mandatory' | translate }}  </mat-error>
                                            <mat-error class="margin_tp"
                                                *ngIf="codeForm.controls['CdSeq'].touched && codeForm.controls['CdSeq'].errors?.pattern">
                                                {{ 'header.code-data.table.Invalid' | translate }}
                                            </mat-error>
                                            <mat-error class="margin_tp"
                                                *ngIf="codeForm.controls['CdSeq'].touched && codeForm.controls['CdSeq'].errors?.maxlength">
                                                Enter maximum 4 digits
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <div class="">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>{{ 'header.code-data.table.CodeProc' | translate
                                                }}</mat-label> <input onkeydown="return (event.keyCode!=13);" matInput
                                                formControlName="CdProc" [readonly]="isReadonlyDelete"
                                                placeholder="CdProc" maxlength="25" required>
                                            <mat-error class="margin_tp"
                                                *ngIf="codeForm.controls['CdProc'].touched && codeForm.controls['CdProc'].errors?.required">
                                                {{ 'header.code-data.table.Mandatory' | translate }}</mat-error>
                                            <mat-error class="margin_tp"
                                                *ngIf="codeForm.controls['CdProc'].touched && codeForm.controls['CdProc'].errors?.pattern">
                                                {{ 'header.code-data.table.Invalid' | translate }}
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-5">
                                <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-4 mt-1">
                                                <mat-label class="mt-1 lclass">
                                                    <span class="required-asterisk mr-1 mt-4">{{
                                                        'header.code-data.table.CodeActive' | translate
                                                        }}</span>

                                                </mat-label>
                                            </div>
                                            <div class="col-sm-7 mt-1">
                                                <mat-radio-group [disabled]="isReadonlyDelete"
                                                    onkeydown="return (event.keyCode!=13);" formControlName="CdActive"
                                                    class="example-full-width">
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <mat-radio-button value='Y'>{{ 'header.code-data.table.Yes' | translate }}</mat-radio-button>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <mat-radio-button value='N'>{{ 'header.code-data.table.No' | translate }}</mat-radio-button>
                                                        </div>
                                                    </div>
                                                </mat-radio-group>
                                            </div>
                                        </div>
                                </div>
                            </div>
                            <div class="row prpl">
                            <div class="col-sm-12 ">

                                <button id="Save" type="button" *ngIf="submitButton && CodeCreate" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                            (click)="submit()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/save.gif"
                                                    style="margin-right: 5px;">
                                                {{ 'header.code-data.table.Save' | translate }}
                                            </span>
                                        </button>
                                        <button id="Update" type="button" *ngIf="editButton && CodeUpdate" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                        (click)="update()">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/img/edit1.gif"
                                                style="margin-right: 5px;">
                                            {{ 'header.code-data.table.Update' | translate }}
                                        </span>
                                    </button>
                                    <button id="Delete" type="button" *ngIf="deleteButton && CodeDelete" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                    (click)="openConformationModalBox()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/trash.gif"
                                            style="margin-right: 5px;">
                                        {{ 'header.code-data.table.Delete' | translate }}
                                    </span>
                                </button>
                                <button id="Back" (click)="back()" type="button"
                                class="btn btn-primary fr sz btn-icon-text floatright mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/turn-left.gif"
                                        style="margin-right: 5px;">
                                    {{ 'header.code-data.table.Back' | translate }}
                                </span>
                            </button>
                                </div>
                            </div>
                        </div>
                        <hr *ngIf="showTable">
                        <div *ngIf="showTable" class="pl-3">
                            <h4 class="main-content-label mb-1 ">
                                <b>{{ 'header.code-data.table.CodeData' | translate }}</b>
                            </h4>
                            <p class="text-muted card-sub-title mb-0"> {{ 'header.code-data.table.List' | translate }}</p>
                        </div>
                        <hr *ngIf="showTable">
                        <div *ngIf="showTable" class="table-responsive table-container mt-4 pl-3">
                            <table class="table  table-bordered text-nowrap text-left">
                                <thead>
                                    <tr class="text-left">
                                        <th class="f600"> {{'header.code-data.table.Type' | translate }} </th>
                                        <th class="f600"> {{ 'header.code-data.table.Code' | translate }} </th>
                                        <th class="f600"> {{ 'header.code-data.table.CodeDescription' | translate }}
                                        </th>
                                        <th class="f600"> {{ 'header.code-data.table.CodeSequence' | translate }}
                                        </th>
                                        <th class="f600"> {{ 'header.code-data.table.CodeActive' | translate }}
                                        </th>
                                        <th class="f600"> {{ 'header.code-data.table.CodeProc' | translate }} </th>
                                        <th width="10%" class="f600 text-center"> {{ 'header.code-data.table.Action'
                                            | translate }}</th>
                                    </tr>
                                </thead>
                                <tbody id="table_data">
                                    <tr *ngFor="let codedata of codeList;">
                                        <td> {{codedata.CdType}} </td>
                                        <td>{{codedata.CdCode}} </td>
                                        <td> {{codedata.CdDesc}} </td>
                                        <td>{{codedata.CdSeq}} </td>
                                        <td>{{codedata.CdActive}} </td>
                                        <td>{{codedata.CdProc}} </td>
                                        <td class="text-center"> <a class="floating" title="Edit"
                                                (click)="editdata('true',codedata)"> <i class="fa fa-edit"></i>
                                            </a> <a class="floating" title="Delete" (click)="deletee('true',codedata)">
                                                <i class="fas fa-trash"></i>
                                            </a> </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </form>
            </div>
        </div>
</div>